import { simpleCopy } from '@/utils/deepCopy';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { ForecastService } from '@/coreDomainsModule/services/forecastService';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { BusinessService as BS } from '@/coreDomainsModule/services/businessService';
import { IArrival, OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { IDate } from '@/coreDomainsModule/date';
import { IAnnounce } from '@/coreDomainsModule/entities/forecast';
import { AnnounceService } from './announceService';
/**
 * 内示を操作するためのサービス
 */
export class BusinessService extends BS {
  /**
   * 在庫シミュレーション用に、IBusinessを加工する
   * @param business - 取引情報
   */
  public static convertRecommendEditBusiness(business: IBusiness): IBusiness {
    const output = simpleCopy(business);

    // executionDate以前の発注情報はいらない(executionDateがnullはありえない)
    const executionDate = output.executionDate;
    if (executionDate != null) {
      output.recommend = output.recommend?.filter((recommendation) => {
        const arrivalDate = recommendation.crossDate;
        if (arrivalDate != null && this.getEvalValue(arrivalDate) > this.getEvalValue(DateService.convertDateToIDate(executionDate))) {
          return true;
        }
        return false;
      });
    }

    // 内示情報を受領年月が最新のもののみに加工を行う
    // FIXME: 本当はAdapterでやることだが、過去情報を持たせるための定義が無いのと、時間ないので一旦ここでやっている
    const customerAnnounces: IAnnounce[] = AnnounceService.extractNewestCustomerAnnounces(output);

    // 既存のcustomerAnnounce ^ 今月から数えて４ヶ月分の枠を作成する（存在しない月の場合はamountを0にする）
    const emptyAnnounce = [];
    ForecastService.setAnnounceYearMonth(emptyAnnounce, new Date()); // 空の配列に今月から数えて４ヶ月分の枠を作成する
    emptyAnnounce.forEach((announce) => {
      const target = customerAnnounces.find((item) => {
        return DateService.equalYearMonthInfo(item, announce);
      });
      if (!target) {
        // 存在しない月の場合はamountを0にする
        customerAnnounces.push(announce);
      }
    });
    // 昇順にソートしておく
    output.customerAnnounce = ForecastService.sortAnnounce(customerAnnounces || []);
    return output;
  }

  /**
   * executionDate以前での発注済み未納を取得する
   * @param business - 取得した取引情報
   */
  public static getUnpaidOrderedOrder(business: IBusiness): IArrival[] {
    const executionDate = business.executionDate;
    if (!executionDate) {
      // executionDateがないのはありえないが、もしなかったら空の配列を返す
      return [];
    }
    const output = simpleCopy(business.recommend)?.filter((recommendation) => {
      const arrivalDate = recommendation.crossDate;
      // 分納がある場合、分納取引のうち1つでも条件に引っかかっていたらTrueにする
      if (recommendation.status === OrderStatus.PartialDelivery && recommendation.partialDeliveries) {
        return recommendation.partialDeliveries.some(
          (pd) =>
            pd.crossDate &&
            this.getEvalValue(pd.crossDate) <= this.getEvalValue(DateService.convertDateToIDate(executionDate)) &&
            pd.status !== 'Delivered' &&
            pd.status !== 'DisplayEnded'
        );
      }
      // ArrivalDateが存在し、executionDate以前であり、かつ納入済み、納入遅延、表示終了のステータスでないものを取得する
      return (
        arrivalDate &&
        this.getEvalValue(arrivalDate) <= this.getEvalValue(DateService.convertDateToIDate(executionDate)) &&
        recommendation.status !== 'Delivered' &&
        recommendation.status !== 'DisplayEnded'
      );
    });
    return output;
  }

  /**
   * 推奨発注を取得する
   * @param arrival - 入荷情報
   */
  private static getEvalValue = function (arrival: IArrival | IDate): number {
    if (!arrival) {
      return 0;
    }
    return arrival.year * 10000 + arrival.month * 100 + arrival.day;
  };
}
